import Blog from 'components/Blog';
import { Dispatch, SetStateAction } from 'react';
import { BizAnalystBanner } from './biz-analyst-banner';
import GrowingBusiness from './growing-business';
import LandingPageHeader from './header';
import Portfolio from './portfolio-section';
import { checkForMobileDevice } from 'utils/browserUtils';

interface MainContentProps {
  setPhoneNumber?: Dispatch<SetStateAction<string>>;
  handleLoginModal?: ({
    open,
    phoneNumber
  }: {
    open: boolean;
    phoneNumber?: string;
  }) => void;
  updateSourceToLoginPopup?: Dispatch<SetStateAction<string>>;
}

const MainContent = ({
  setPhoneNumber,
  handleLoginModal,
  updateSourceToLoginPopup
}: MainContentProps) => {
  const isMobile = checkForMobileDevice();
  return (
    <>
      <LandingPageHeader
        setPhoneNumber={setPhoneNumber}
        handleLoginModal={handleLoginModal}
        updateSourceToLoginPopup={updateSourceToLoginPopup}
      />
      <GrowingBusiness />
      <Portfolio />
      <BizAnalystBanner />
      <Blog fetch={true} />
    </>
  );
};

export default MainContent;
